import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const statusCategoryAPI = createApi({
    reducerPath: "statusCategoryAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        getAllStatusCategoriesWithPagination: builder.mutation({
            query: (data) => ({
                url: "/StatusCategory/GetAllStatusCategoriesWithPagination",
                method: "POST",
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addStatusCategory: builder.mutation({
            query: (data) => ({
                url: "/StatusCategory/AddStatusCategory",
                method: "POST",
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getStatusCategoryById: builder.query({
            query: (statusCategoryId) => ({
                url: `/StatusCategory/GetStatusCategoryById?statusCategoryId=${statusCategoryId}`,
                method: "GET",
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateStatusCategory: builder.mutation({
            query: (data) => ({
                url: "/StatusCategory/UpdateStatusCategory",
                method: "POST",
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteStatusCategory: builder.mutation({
            query: (statusCategoryId) => ({
                url: `/StatusCategory/DeleteStatusCategory?statusCategoryId=${statusCategoryId}`,
                method: "DELETE",
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const {
    useGetAllStatusCategoriesWithPaginationMutation,
    useAddStatusCategoryMutation,
    useGetStatusCategoryByIdQuery,
    useUpdateStatusCategoryMutation,
    useDeleteStatusCategoryMutation,
} = statusCategoryAPI;

export default statusCategoryAPI;
